import { captureScreenshot } from "./capture";
import { redactPIIInDOM } from "./redact";
import { waitForStableRender, RenderStabilityOptions } from "./renderStability";

/**
 * Takes a screenshot of the current page after ensuring content is stably rendered
 * @param options Optional configuration for render stability checking
 * @returns Promise resolving to the screenshot as a data URL
 */
async function screenshot(options?: RenderStabilityOptions) {
    try {
        // Wait for page to be stably rendered
        await waitForStableRender(options);

        // Clone the document body to avoid modifying the original
        const clonedBody = document.body.cloneNode(true) as HTMLElement;

        // Redact PII in text content
        redactPIIInDOM(clonedBody);

        // Capture the screenshot
        const imageDataUrl = await captureScreenshot(clonedBody);

        return imageDataUrl;
    } catch (error) {
        console.error('An error occurred:', error);
    }
}

export { screenshot };
